import { SITE } from "../config/site";

export default function Terms() {
  return (
    <main className="mx-auto max-w-5xl px-4 py-10 sm:px-6 lg:px-8">
      <div className="rounded-[2rem] border border-slate-200 bg-white p-6 shadow-sm sm:p-8">
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#e46a2e]">Terms</p>
        <h1 className="mt-2 text-3xl font-black tracking-tight text-slate-950">Shopping terms and support notes</h1>

        <div className="mt-6 space-y-4 text-sm leading-7 text-slate-600">
          <p>
            Product availability may change as new stock arrives and popular pairs sell out. If you need confirmation before checkout, contact the shop directly.
          </p>
          <p>
            Payments and order confirmation can be completed through cash, M-Pesa, bank transfer, or WhatsApp-assisted support depending on your selected checkout option.
          </p>
          <p>
            For any issue related to orders or store support, reach us at {SITE.phoneDisplay} or {SITE.email}.
          </p>
        </div>
      </div>
    </main>
  );
}